import { render, staticRenderFns } from "./finish_add.vue?vue&type=template&id=288c4592&scoped=true&"
import script from "./finish_add.vue?vue&type=script&lang=js&"
export * from "./finish_add.vue?vue&type=script&lang=js&"
import style0 from "./finish_add.vue?vue&type=style&index=0&id=288c4592&prod&scoped=true&lang=scss&"
import style1 from "./finish_add.vue?vue&type=style&index=1&id=288c4592&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288c4592",
  null
  
)

export default component.exports